<ng-container
  *ngIf="(tokenService.isAuthentication | async) !== null; else loading"
>
  <router-outlet></router-outlet>
</ng-container>

<ng-template #loading>
  <div
    class="splash-screen position-fixed d-flex justify-content-center align-items-center flex-direction-column"
  >
    <!-- logo hoặc spinner -->
    <img src="clb-lhl-logo.jpg" class="logo" />
    <div class="position-fixed bottom-0 d-flex align-items-center font-screen">
      From
      <p>LA HẦU LA</p>
    </div>
  </div>
</ng-template>
